<template>
    <div
        :class="[`kc-help-text ${variant}`, alwaysExpanded || expanded ? {expanded} : {}]"
        data-cy="kcHelpText"
    >
        <h5
            class="kc-help-text-header"
            data-cy="kcHelpTextHeader"
        >
            <slot name="header" />
        </h5>

        <BCollapse
            ref="content"
            :aria-expanded="alwaysExpanded || expanded ? 'true' : 'false'"
            class="kc-help-text-content"
            data-cy="kcHelpTextCollapse"
            :visible="expanded"
        >
            <slot ref="defaultSlot" />

            <div
                class="kc-help-text-truncate"
                data-cy="kcHelpTextTruncate"
            >
                <FontAwesomeIcon
                    data-cy="kcHelpTextTruncateIcon"
                    :icon="['far', 'ellipsis-h']"
                />
            </div>
        </BCollapse>

        <div
            v-if="!alwaysExpanded"
            class="kc-help-text-footer"
        >
            <button
                :aria-expanded="expanded ? 'true' : 'false'"
                aria-controls="helpTextCollapse"
                class="kc-help-text-btn-see-more"
                data-cy="kcHelpTextToggleButton"
                @click="toggle"
            >
                See More
                <FontAwesomeIcon
                    class="kc-help-text-btn-see-more-icon"
                    data-cy="kcHelpTextToggleButtonIcon"
                    icon="angle-down"
                />
            </button>
        </div>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {
        faEllipsisH,
    } from '@fortawesome/pro-regular-svg-icons';
    import {
        faAngleDown,
    } from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(
        faAngleDown,
        faEllipsisH,
    );

    export const eventName = 'kc::help-text::expanded';

    /**
     * @group Content
     * A component to display help text to the user. Not intended for use in admins (within the Platform).
     */
    export default {
        name: 'KCHelpText',
        components: {
            FontAwesomeIcon,
        },
        model: {
            prop: 'expanded',
            event: eventName,
        },
        props: {
            expanded: {
                type: Boolean,
                required: false,
                // `true`
                default: true,
            },
            alwaysExpanded: {
                type: Boolean,
                required: false,
                default: false
            },
            variant: {
                type: String,
                requred: false,
                default: 'blue',
                validator: (value) => {
                    return ['green', 'white', 'blue'].includes(value);
                }
            }
        },
        methods: {
            toggle() {
                this.$emit(eventName, !this.expanded);
            },
        },
    };
</script>
